const currencyRegex: RegExp = /(£)/g

// "Win 50p Credit" -> "Win 50c Credit"
const currencyDecimalRegex: RegExp = /([a-z]+ [0-9]+)p( [a-z]+)/gi

export const translateCurrency = (
  dataObject: any,
  currencySymbol: string,
  currencyDecimalSymbol: string
): typeof dataObject => {
  // no need to translate if £
  if (currencySymbol === '£') {
    return dataObject
  }

  const dataObjectString: string = JSON.stringify(dataObject)

  const translatedString: string = dataObjectString
    .replace(currencyRegex, currencySymbol)
    .replace(currencyDecimalRegex, `$1${currencyDecimalSymbol}$2`)

  return JSON.parse(translatedString)
}
